import { reactive } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import route from '@/types/Route';
export default function useClientForm(examination, initialFormData, limit = '15', selectedUsers, resetSelection, closeModal) {
    const form = reactive({ ...initialFormData });
    // 検索ボタンがクリックされたときの処理
    const onSearchButtonClicked = () => {
        Inertia.get(route('examinations.showAddExamination', { examination: examination.value.id }), {
            userId: form.userId,
            name: form.name,
            email: form.email,
            school: form.selectedSchool,
            linkedStatus: form.linkedStatus,
            limit,
        });
    };
    // リセットボタンがクリックされたときの処理
    const onResetButtonClicked = () => {
        form.userId = '';
        form.name = '';
        form.email = '';
        form.selectedSchool = '';
        form.linkedStatus = '';
        Inertia.get(route('examinations.showAddExamination', { examination: examination.value.id }), {
            limit,
        });
    };
    // 選択したユーザに模試を付与する
    const onAddExaminationToUsersClicked = () => {
        Inertia.post(route('examinations.addExamination'), {
            examinationId: examination.value.id,
            userIds: selectedUsers.value.map(user => user.id),
        }, {
            onSuccess: () => {
                selectedUsers.value = [];
                resetSelection.value = true;
                setTimeout(() => {
                    resetSelection.value = false;
                }, 0);
                closeModal();
            },
        });
    };
    // 選択したユーザの模試を削除する
    const ondeleteExaminationFromUsersClicked = () => {
        Inertia.delete(route('examinations.deleteExaminationFromUsers'), {
            data: {
                examinationId: examination.value.id,
                userIds: selectedUsers.value.map(user => user.id),
            },
            onSuccess: () => {
                selectedUsers.value = [];
                resetSelection.value = true;
                setTimeout(() => {
                    resetSelection.value = false;
                }, 0);
                closeModal();
            },
        });
    };
    return {
        form,
        onSearchButtonClicked,
        onResetButtonClicked,
        onAddExaminationToUsersClicked,
        ondeleteExaminationFromUsersClicked,
    };
}
